const addAuthHeader = (headers: Record<string, unknown>, token: string) => ({
  ...headers,
  authorization: `Bearer ${token}`,
});

export default addAuthHeader;
